<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <nav
    class="sidebar"
    :class="{ 'open': mouseIn || sidebarFixed }"
    @mouseenter="mouseIn = true"
    @focusin="mouseIn = true"
    @mouseleave="mouseIn = false"
    @focusout="mouseIn = false"
  >
    <div class="sidebar--elements">
      <SidebarLink
        v-for="item in nav"
        :key="item.index"
        ref="links"
        :is-open="mouseIn || sidebarFixed"
        :item="item"
        :url-path="urlPath"
        :layer="0"
        @showChildren="hideOtherLinkChildren"
      />
    </div>

    <slot name="additional" />
  </nav>
</template>

<script>
import { mapState } from 'vuex';
import SidebarLink from './SidebarLink.vue';

export default {
  components: {
    SidebarLink,
  },

  props: {
    nav: {
      type: Array,
    },
  },

  data() {
    return {
      mouseIn: false,
      urlPath: window.location.pathname,
    };
  },

  computed: {
    ...mapState([
      'sidebarFixed',
    ]),
  },

  watch: {
    mouseIn() {
      if (!this.mouseIn && !this.sidebarFixed) {
        this.hideOtherLinkChildren();
      }
    },
    sidebarFixed() {
      if (!this.mouseIn && !this.sidebarFixed) {
        this.hideOtherLinkChildren();
      }

      this.setBodyClass();
    },
  },

  beforeMount() {
    this.setBodyClass();
  },

  methods: {
    hideOtherLinkChildren(newOpenedLink = null) {
      (this.$refs.links || []).forEach((link) => {
        if (link !== newOpenedLink) {
          link.hideChildren();
        }
      });
    },
    setBodyClass() {
      document.body.classList[this.sidebarFixed ? 'add' : 'remove']('sidebar-open');
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  &--elements {
    overflow-x: hidden;
  }
}
</style>
